import React, { useState, useEffect, useContext } from "react";
import Menu from "../components/navbar.js";
import "../styles/style.css";
import "../styles/chart.css";
import "../styles/analytics.css";
import { api_domain } from "../config"
import {useLocation} from "react-router-dom";
import { AuthContext } from "../components/AuthContext";

// Chart docs:
// https://upmostly.com/tutorials/how-to-use-chart-js-with-react
import Chart from "chart.js/auto";
import { Bar} from "react-chartjs-2";

export function Analytics(year) {
    // let y = year;
    // if (typeof year === "undefined" || Analytics.year === undefined) {
    //   y = 2024;
    // } 
    const [topDomains, setTopDomains] = useState(null);
    const [topLandingDomains, setTopLandingDomains] = useState(null);

    const [adYears, setAdYears] = useState(null);

    const { basicHttpAuthString } = useContext(AuthContext);

    useEffect(() => {
        fetch(`${api_domain}/report/top_parent`, {
          headers: {
            Authorization: `${basicHttpAuthString}`
          }
        })
          .then((response) => response.json())
          .then((data) => setTopDomains(data));
    }, [])

    useEffect(() => {
      fetch(`${api_domain}/report/top_landing`, {
        headers: {
          Authorization: `${basicHttpAuthString}`
        }
      })
        .then((response) => response.json())
        .then((data) => setTopLandingDomains(data));
  }, [])
  
//   useEffect(() => {
//     fetch(`${api_domain}/report/ads_by_year`)
//       .then((response) => response.json())
//       .then((data) => setAdYears(data));
// }, [])
    
  const parentDomains = getParentDomains(topDomains);
  const landingDomains = getLandingDomains(topLandingDomains);
  const parentDomainsMap = GetParentHyperlinkList(topDomains);
  const landingDomainsMap = GetLandingHyperlinkList(topLandingDomains);
  // const adsByYear = GetAdsByYear();
  // const adsByMonth = GetAdsByMonth(y);

  return (
    <div className="container">
      <Menu/>
      <div className="tools">
        <div className="titleMain">Analytics</div>
        {/* <div className="chart-container">
          {adsByYear}
          {adsByMonth}
          {<select id="floorplanSelect" class="form-control" name="floorplan">
            <option value="2020">2020</option>
            <option value="2021">2021</option>
            <option value="2022">2022</option>
            <option value="2023">2023</option>
            <option value="2024" selected="selected">2024</option>
          </select>}
          </div> */}
          {/* <div class="flex w-3/4 h-[400px]">
            {parentDomains}
          </div>
            <div class="h-[200px] flex items-center justify-center">
            {parentDomainsMap}
          </div> */}
          {/* <div class="flex w-3/4 h-[400px] pb-10">
            {landingDomains}
          </div>
          <div class="h-[200px] flex items-center justify-center">
            {landingDomainsMap}
          </div> */}
          <div class="flex grid grid-flow-row-dense grid-cols-3 grid-rows-2 gap-x-16">
            <div class="h-[375px] col-span-2">{parentDomains}</div>
            <div class="pt-14">{parentDomainsMap}</div>
            <div class="h-[375px] col-span-2">{landingDomains}</div>
            <div class="pt-14">{landingDomainsMap}</div>
          </div>
          {/* <div class="flex items-center sm:flex-row">
            {landingDomains}
          </div> */}
        </div>
   </div>
  )
}

// document.getElementById('floorplanSelect').addEventListener('change', function() {
//   const selectedYear = parseInt(this.value);
//   console.log(selectedYear);
//   //GetAdsByMonth(selectedYear);
//   Analytics(selectedYear);
// });

export function GetParentHyperlinkList(topDomains) {
  const location = useLocation();
  if (!topDomains) {
    return (
        <div>No data to display</div>
    )
  }
  const parentDomainsMap = topDomains.map(item => <li><a className="underline text-blue-600 hover:text-blue-800 visited:text-purple-600" href = {location.pathname.substring(0, location.pathname.indexOf("analytics")) + `search?&parent_domain=${item.domain}&page=1&view=table&blur=true`}>{item.domain}</a></li>);
  return <figure><figcaption>Explore:</figcaption><ol class="list-decimal">{parentDomainsMap}</ol></figure>;
}

export function GetLandingHyperlinkList(topDomains) {
  const location = useLocation();
  if (!topDomains) {
    return (
        <div>No data to display</div>
    )
  }
  const landingDomainsMap = topDomains.map(item => <li><a className="underline text-blue-600 hover:text-blue-800 visited:text-purple-600" href = {location.pathname.substring(0, location.pathname.indexOf("analytics")) + `search?&landing_domain=${item.domain}&page=1&view=table&blur=true`}>{item.domain}</a></li>);
  return <figure><figcaption>Explore:</figcaption><ol class="list-decimal">{landingDomainsMap}</ol></figure>;
}

function getParentDomains(topDomains) {
    if (!topDomains) {
        return (
            <div>No data to display</div>
        )
    }

    const counts = topDomains.map(item => item.count);
    const domains = topDomains.map(item => item.domain);

    const data = {
        labels: domains,
        datasets: [
          {
            label: "# of ads",
            backgroundColor: ['rgba(75,46,131,0.8)', 'rgba(255,215,0,0.8)'],
            data: counts,
          }
        ],
    };

    return <Bar data={data} options={{
      responsive: true,
      maintainAspectRatio: false,
      indexAxis: 'y',
      plugins:{
           title:{display:true, text: "Top 10 Parent Domains", font:{size: 20, family: "Nunito"}},
           legend: {display: false, position: 'right'}}
      }}/>
}

function getLandingDomains(topDomains) {
  if (!topDomains) {
      return (
          <div>No data to display</div>
      )
  }

  const counts = topDomains.map(item => item.count);
  const domains = topDomains.map(item => item.domain);

  const data = {
      labels: domains,
      datasets: [
        {
          label: "# of ads",
          backgroundColor: ['rgba(75,46,131,0.8)', 'rgba(255,215,0,0.8)'],
          data: counts,
        }
      ],
  };

  return <Bar data={data} options={{
    indexAxis: 'y',
    maintainAspectRatio: false,
    responsive: true,
    plugins:{
         title:{display: true, text: "Top 10 Landing Domains", font:{size: 20, family: "Nunito"}},
         legend: {display: false, position: 'right'}}
    }}/>
}

// // returns a bar graph for the count of baches/year since 2020
// function GetAdsByYear() {

//   const [adYears, setAdYears] = useState(null);
//   useEffect(() => {
//     fetch(`${api_domain}/report/ads_by_year`)
//       .then((response) => response.json())
//       .then((data) => setAdYears(data));
// }, [])
//   const adDates = adYears;

//   if (!adDates) {
//     return (
//       <div>No data to display</div>
//     )
//   }

//   // generate labels 2020 : +1 : current year
//   const currentYear = new Date().getFullYear();
//   const years = [];
//   for (let year = 2020; year <= currentYear; year++) {
//     years.push(year);
//   }
//   const counts = new Array(years.length).fill(0);
//   adDates['ad_dates'].forEach(date => {
//     const dateObj = new Date(date['capture_timestamp']);

//     const year = dateObj.getFullYear();

//     counts[year - 2020]++;
//   })

//   const data = {
//     labels: years,
//     datasets: [
//       {
//         label: "# of ads",
//         backgroundColor: ['rgba(75,46,131,0.8)', 'rgba(255,215,0,0.8)'],
//         data: counts,
//       }
//     ],
//   };

//   return <Bar data={data}  options = {{plugins: {title:{display:true, text: "Yearly Ad Samples", font:{size: 20, family: "Nunito"}}}}}/>
// }


// // returns a bar graph for the count of ads collected by month
// function GetAdsByMonth(selectedYear) {

//   const [adYears, setAdYears] = useState(null);
//   useEffect(() => {
//     fetch(`${api_domain}/report/ads_by_year`)
//       .then((response) => response.json())
//       .then((data) => setAdYears(data));
// }, [])
//   const adDates = adYears;

//   if (!adDates) {
//     return (
//       <div>No data to display</div>
//     )
//   }

//   // generate labels 2020 : +1 : current year
//   const year_filter = selectedYear;

//   // const currentYear = new Date().getFullYear();
//   // const years = [];
//   // for (let year = 2020; year <= currentYear; year++) {
//   //   years.push(year);
//   // }

//   const counts = new Array(12).fill(0);
//   adDates['ad_dates'].forEach(date => {
//     const dateObj = new Date(date['capture_timestamp']);

//     const year = dateObj.getFullYear();

//     if (year === year_filter) {
//       counts[dateObj.getMonth() + 1]++;
//     }
//   })

//   const data = {
//     labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
//     datasets: [
//       {
//         label: "# of ads",
//         backgroundColor: ['rgba(75,46,131,0.8)', 'rgba(255,215,0,0.8)'],
//         data: counts,
//       }
//     ],
//   };

//   return <Bar data={data}  options = {{plugins: {title:{display:true, text: "Monthly Ad Samples", font:{size: 20, family: "Nunito"}}}}}/>
// }
